import { useEffect, useState } from 'react';
import './MultistepForm.scss';
import PropTypes from "prop-types";

const MultistepForm = ({isValid, children, onSubmitClick, submitLabel, initialStep}) => {
    const [currentStep, setCurrentStep] = useState();
    useEffect(() => {
        setCurrentStep(initialStep || 0);
    }, [initialStep]);
    const handlePreviousClick = () => isValid && setCurrentStep(currentStep - 1);
    const handleNextClick = () => isValid && setCurrentStep(currentStep + 1);
    const buttonClassName = `multistep-form-button ${!isValid ? 'multistep-form-button--disabled' : ''}`;
    const hasPreviousStep = currentStep > 0;
    const isLastStep = currentStep === (children.length - 1);
    const hasNextStep = !isLastStep;
    return (
        <div>
            <div className="multistep-form-component">
                {children[currentStep]}
            </div>
            <div className="multistep-form-component-buttons">
                {hasPreviousStep && <button className={buttonClassName} onClick={handlePreviousClick}>Previous</button>}
                {hasNextStep && <button className={buttonClassName} onClick={handleNextClick}>Next</button>}
                {isLastStep && <button className={buttonClassName} onClick={onSubmitClick}>{submitLabel}</button>}
            </div>
        </div>
    );
}

MultistepForm.propTypes = {
    isValid: PropTypes.bool,
    submitLabel: PropTypes.string,
    children: PropTypes.node.isRequired,
    onSubmitClick: PropTypes.func.isRequired,
    initialStep: PropTypes.number
};

export default MultistepForm;
